import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {

    const user = this.auth.getUser();
    const isExpired = this.auth.isTokenExpired();

    if (user && !isExpired) {
      return true;
    }

    if (user && isExpired) {
      this.auth.logout();
    }

    // redireciona para login com return url
    this.router.navigate(['/login'], {
      queryParams: { retUrl: state.url }
    });

    return false;
  }
}